import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";
import Paper from "@mui/material/Paper";

export const MenuContainer = styled.div<{ mobileTopMargin: number }>`
  position: relative;
  margin-top: ${(props) => props.mobileTopMargin}px;
  ${Styles.BreakpointsUtils.desktopOnly(`
    margin-top: 0;  
  `)}
`;

export const WrapperDiv = styled.div<{
  height: number;
  negativeMobileTopMargin: number;
}>`
  height: ${(props) => props.height}px;
  width: 100%;
  position: relative;
  z-index: 10;
  &.active {
    z-index: 102;
  }

  margin-top: -${(props) => props.negativeMobileTopMargin + 4}px;
  ${Styles.BreakpointsUtils.desktopOnly(`
    margin-top: -4px;
  `)}
  ${Styles.BreakpointsUtils.mobileOnly(`
    height: 89px;
  `)}
`;

export const ContainerDiv = styled.div<{ defaultColor: string }>`
  background-color: ${(props) => props.defaultColor};
  ${Styles.PageColorUtils.pageColorThemeOnly(
    (pageColor: any) => `
      background-color: ${pageColor.mainColor};
    `
  )}
  ${Styles.BreakpointsUtils.desktopOnly(`
    position: absolute;
    z-index: 9;
    width: 100%;
    height: 65px;
  `)}

  .prodotto-menu-secondario-no-calcolo-btn & {
    #calcolo_btn {
      display: none;
    }
  }
`;

export const Content = styled.div<{ height: number; fontSize: number }>`
  ${Styles.PageColorUtils.pageColorThemeOnly(
    (pageColor: any) => `
      background-color: ${pageColor.mainColor};
    `
  )}

  &.is-sticky {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;
  }

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #fff;

  ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
    justify-content: center;
    padding-left: calc(100% * 2.25 / 24);
    
    height: 65px;
    max-width: 1280px;
    &.is-sticky {
      padding-left: 4%;
      max-width: 1280px;
      &:after {
        content: '';
        z-index: -1;
        position: fixed;
        top: 0;
        left: 0;
        height: inherit;
        width: 100%;
        background: inherit;
      }
    }
  `)}

  ${Styles.BreakpointsUtils.desktopOnly(`
    position: relative;
    padding-left: 90px;
    justify-content: flex-start;
    margin: 0 auto;
    &.is-sticky {
      padding: 0;
    }
    &.one-element {
      justify-content: flex-end;
    }
  `)}

  ${Styles.BreakpointsUtils.tabletOnly(`
    justify-content: flex-start;
    padding-left: calc(100% * 1.25 / 24);
  `)}

  ${Styles.BreakpointsUtils.mobileOnly(`
    height: 89px;
    padding-right: 10px;
    align-items: center;
    overflow: hidden;
    &.is-sticky {
      align-items: baseline;
      font-size: 24px;
    }
  `)}
`;

export const Title = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 60px;
  font-family: Unipol Bold;
  font-size: 21px;
  line-height: 29px;
  align-items: center;

  ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
    width: 600px;
  `)}
  ${Styles.BreakpointsUtils.mobileOnly(`
    font-size: 24px;
    padding-left: 34px;
    padding-right: 6px;
    padding-top: 4px;
    align-items: start;

    .is-sticky & { 
      padding-top: 17px;
    }
  `)}

  ${Styles.BreakpointsUtils.desktopOnly(`
    display: none;

    .is-sticky & {
      display: flex;
      width: 307px;
    }
  `)}
`;

export const Menu = styled.div`
  display: none;

  ${Styles.BreakpointsUtils.desktopOnly(`
    display: flex;
    flex-direction: row;
    gap: 5px;
    height: 100%;
    &.container-menu {
      max-width: 700px;
    }
  `)}
`;

export const VoceMenu = styled.div`
  position: relative;
  width: 310px;
  height: 60px;
  font-size: 24px;
  text-align: center;
  line-height: 65px;
  overflow: visible;
  cursor: pointer;

  ${Styles.BreakpointsUtils.desktopOnly(`
    &.more-elements {
      width: 230px
    }
  `)}

  &.active {
    font-family: Unipol Bold;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  .is-sticky & {
    width: 239px;

    .tpd-short-text-container {
      height: 65px;
    }
  }
`;

export const CTAPreventivoContainer = styled.div`
  background-color: #c4151c;
  padding: 12px 35px;
  height: 45px;
  width: 100%;
  max-width: 210px;

  .tpd-cta-container {
    text-decoration: none;
    font-size: 16px;
    font-family: Unipol Bold;
    text-align: center;

    a {
      color: #fff;
    }
  }

  ${Styles.BreakpointsUtils.tabletOnly(`
    max-width: 140px;
    padding: 8px;
    text-align: center;
    height: 45px;
    line-height: 1;
  `)}

  ${Styles.BreakpointsUtils.mobileOnly(`
    padding: 12px 10px;
    height: 55px;
    width: 90px;
    line-height: 17px;
    text-align: center;
  `)}
`;

export const Triangle = styled.div`
  display: block;
  position: absolute;
  bottom: -5px;
  left: 50%;
  margin-left: -20px;
  width: 40px;
  height: 15px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 15px solid #fff;
`;

export const DropTriangle = styled.div`
  display: block;
  position: absolute;
  top: -20px;
  left: 50%;
  margin-left: -40px;
  width: 44px;
  height: 20px;
  border-left: 22px solid transparent;
  border-right: 22px solid transparent;
  ${Styles.PageColorUtils.pageColorThemeOnly(
    (pageColor: any) => `
      border-top:20px solid ${pageColor.mainColor};
    `
  )}

  ${Styles.BreakpointsUtils.mobileOnly(`
    left: 60%;
    margin-left: -30px;
  `)}
`;

export const Dropdown = styled.div`
  display: flex;
  justify-content: center;
  width: calc(100% * 6 / 24);

  ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
    width: calc(100% * 4 / 24);
  `)}

  ${Styles.BreakpointsUtils.desktopOnly(`
    display: flex;
    align-items: center;
    justify-content: start;
    height: 65px;
  `)}
`;

export const Button = styled.button`
  height: fit-content;
  background-color: transparent;
  border: none;
  font-size: 32px;
  color: #fff;
  ${Styles.BreakpointsUtils.desktopOnly(`
  min-width: 204px;
  &.icon-Share {
    position: absolute;
    right: 0;
  }
`)}

  &.icon-Share {
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const WrapperPaper = styled.div`
  position: absolute;
  display: flex;
  align-items: baseline;
  margin-left: 55px;

  ${Styles.BreakpointsUtils.mobileOnly(`
    margin-left: 0px;
`)}

  ${Styles.BreakpointsUtils.tabletOnly(`
      justify-content: flex-end;
      margin-left: 140px;
    `)}
`;

export const PaperDiv = styled(Paper)`
  background-color: unset;
  border-radius: 0;
  box-shadow: none;
  margin-left: -50px;

  &.popup-container-social {
    position: absolute;
    margin-top: 46px;
    margin-left: 53px;
    ${Styles.BreakpointsUtils.tabletOnly(`
      margin-top: 64px;
  `)}
    ${Styles.BreakpointsUtils.mobileOnly(`
      margin-top: 66px;
      margin-left: -17px;
      position: relative
  `)}

    z-index: 2
  }
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  ${Styles.PageColorUtils.pageColorThemeOnly(
    (pageColor: any) => `
      background-color: ${pageColor.mainColor};
    `
  )}
  box-shadow: none;

  margin-right: 30px;
  ${Styles.BreakpointsUtils.mobileOnly(`
    margin-right: 10px;
    position: relative;
    top: 8px;
  `)}
`;

export const Option = styled.a`
  padding: 6px 16px;
  font-size: 46px;
  color: #fff;
  text-decoration: none;

  &:hover {
    color: #fff;
  }
`;
